if (!customElements.get("media-gallery-mobile")) {
  customElements.define(
    "media-gallery-mobile",
    class MediaGalleryMobile extends HTMLElement {
      constructor() {
        super();

        this.selectors = {
          container: ".m-main-product--wrapper",
          slider: ".swiper-container",
          sliderPagination: ".swiper-pagination",
          sliderPrevEl: ".swiper-button-prev",
          sliderNextEl: ".swiper-button-next",
          navSlider: ".nav-swiper-container",
          medias: [".m-product-media--item"],
          mediaWrapper: ".m-product-media--wrapper",
          mediaZoomIns: [".m-product-media__zoom-in"],
          videos: [".media-video"],
          variantIdNode: '[name="id"]',
          featuredImage: ".m-product-media",
        };

        this.container = this.closest(this.selectors.container);
        this.domNodes = queryDomNodes(this.selectors, this);

        this.enableVideoAutoplay =
          this.dataset.enableVideoAutoplay === "true";

        this.enableImageZoom =
          this.dataset.enableImageZoom === "true";

        this.enableVariantGroupImages =
          this.dataset.enableVariantGroupImages === "true";

        this.show_featured_media =
          this.dataset.showFeaturedMedia === "true";

        this.onlyMedia =
          this.dataset.onlyMedia === "true";

        if (this.container) {
          this.view =
            this.container.dataset.view ||
            "product-template";
        }

        this.section = this.closest(
          `[data-section-id="${this.sectionId}"]`
        );

        this.layout = this.dataset.layout;
      }

      connectedCallback() {
        this.setupData();
      }

      async setupData() {
        this.productHandle = this.dataset.productHandle;
        this.productUrl = this.dataset.productUrl;

        this.productData = await this.getProductJson(
          this.productUrl
        );

        const {
          productData,
          productData: { variants } = {},
        } = this;

        const variantIdNode =
          this.container.querySelector(
            this.selectors.variantIdNode
          );

        if (productData && variantIdNode) {
          let currentVariantId =
            Number(variantIdNode.value);

          if (!currentVariantId) {
            currentVariantId =
              productData
                .selected_or_first_available_variant.id;
          }

          const currentVariant =
            variants.find(
              (v) => v.id === currentVariantId
            ) || variants[0];

          this.productData.initialVariant =
            currentVariant;

          if (
            !this.productData.selected_variant &&
            variantIdNode.dataset.selectedVariant
          ) {
            this.productData.selected_variant =
              variants.find(
                (v) =>
                  v.id ===
                  Number(
                    variantIdNode.dataset.selectedVariant
                  )
              );
          }

          this.init();
        }
      }

      init() {
        const variantPicker =
          this.container.querySelector(
            "variant-picker"
          );

        this.handlePhotoswipe();
        this.initPhotoswipe();
        this.initSlider();

        // Handle autoplay video
        this.handleAutoplayVideo();

        if (!variantPicker) {
          this.initPhotoswipe();
          this.handleSlideChange();
          this.removeAttribute(
            "data-media-loading"
          );

          if (this.firstElementChild) {
            this.firstElementChild.style.opacity = 1;
          }
        }
      }

      initSlider() {
        if (!this.domNodes.slider) return;

        this.mediaMode = "slider";

        const {
          domNodes: {
            slider,
            sliderPagination,
            navSlider,
            sliderNextEl: nextEl,
            sliderPrevEl: prevEl,
          },
        } = this;

        let initialSlide = 0;
        let configNav = {};
        let config = {};

        if (
          this.productData.initialVariant &&
          this.productData.selected_variant &&
          this.productData.initialVariant.featured_media &&
          !this.show_featured_media
        ) {
          initialSlide =
            this.productData.initialVariant.featured_media
              .position - 1 || 0;
        }

        configNav = {
          loop: false,
          initialSlide,
          slidesPerView: 5,
          freeMode: true,
          spaceBetween: 10,
          threshold: 2,
          watchSlidesVisibility: true,
          watchSlidesProgress: true,

          on: {
            init: () =>
              navSlider &&
              (navSlider.style.opacity = 1),
          },
        };

        this.navSlider = navSlider
          ? new MinimogLibs.Swiper(
              navSlider,
              configNav
            )
          : null;

        const thumbs = this.navSlider
          ? {
              thumbs: {
                swiper: this.navSlider,
              },
            }
          : {};

        config = {
          initialSlide,
          autoHeight: true,

          navigation: {
            nextEl,
            prevEl,
          },

          threshold: 2,

          loop: this.enableVariantGroupImages
            ? false
            : true,

          pagination: {
            el: sliderPagination,
            clickable: true,
            type: "bullets",
          },

          ...thumbs,

          on: {
            init: () => {
              slider.style.opacity = 1;

              this.domNodes =
                queryDomNodes(
                  this.selectors,
                  this.container
                );

              // Try autoplay after Swiper is ready
              requestAnimationFrame(() => {
                this.handleAutoplayVideo();
              });
            },
          },
        };

        this.slider =
          new MinimogLibs.Swiper(
            slider,
            config
          );

        if (!this.enableVariantGroupImages) {
          this.handleSlideChange();
        }
      }

      handleSlideChange() {
        if (!this.slider) return;

        let draggable = true;
        let mediaType = "";
        let visibleSlides = [];

        this.slider.on(
          "slideChange",
          (swiper) => {
            window.pauseAllMedia(this);

            try {
              const {
                slides,
                activeIndex,
              } = swiper;

              const activeSlide =
                slides[activeIndex];

              if (activeSlide) {
                this.playActiveMedia(
                  activeSlide
                );
              }

              visibleSlides = [activeIndex];

              for (
                let index of visibleSlides
              ) {
                const currSlide =
                  slides[index];

                if (currSlide) {
                  mediaType =
                    currSlide.dataset.mediaType;
                }

                if (
                  mediaType === "model"
                ) {
                  break;
                }
              }

              // Disable slider touch when model
              if (
                mediaType === "model"
              ) {
                this.slider.allowTouchMove =
                  false;

                draggable = false;
              } else {
                if (!draggable) {
                  this.slider.allowTouchMove =
                    true;
                }

                draggable = true;
              }
            } catch (error) {
              console.error(
                "Failed to execute slideChange event.",
                error
              );
            }
          }
        );
      }

      handleAutoplayVideo() {
        if (this.slider) {
          const {
            slides,
            activeIndex,
          } = this.slider;

          const activeSlide =
            slides[activeIndex];

          if (!activeSlide) return;

          const mediaType =
            activeSlide.dataset.mediaType;

          if (
            mediaType === "video" ||
            mediaType === "external_video"
          ) {
            this.playActiveMedia(
              activeSlide
            );
          }
        } else {
          const allMedia =
            this.querySelectorAll(
              ".m-product-media--item"
            );

          allMedia.forEach((media) => {
            const mediaType =
              media.dataset.mediaType;

            if (
              mediaType === "video" ||
              mediaType === "external_video"
            ) {
              this.playActiveMedia(media);
            }
          });
        }
      }

      playActiveMedia(selected) {
        const deferredMedia =
          selected.querySelector(
            "deferred-media"
          );

        if (!deferredMedia) return;

        const autoplay =
          deferredMedia.dataset.autoPlay ===
          "true";

        if (!autoplay) return;

        /*
         * Native Shopify video
         */
        const playNativeVideo = (video) => {
          if (!video) return;

          // Safari autoplay requirements
          video.muted = true;
          video.defaultMuted = true;
          video.playsInline = true;

          video.setAttribute(
            "muted",
            ""
          );

          video.setAttribute(
            "playsinline",
            ""
          );

          video.setAttribute(
            "webkit-playsinline",
            ""
          );

          video.setAttribute(
            "autoplay",
            ""
          );

          const playVideo = () => {
            if (!video.paused) return;

            const promise =
              video.play();

            if (promise !== undefined) {
              promise.catch(() => {});
            }
          };

          /*
           * Video already ready
           */
          if (video.readyState >= 2) {
            playVideo();
          }

          /*
           * Safari can create video first
           * and load source afterward.
           */
          video.addEventListener(
            "loadeddata",
            playVideo,
            { once: true }
          );

          video.addEventListener(
            "canplay",
            playVideo,
            { once: true }
          );

          video.addEventListener(
            "canplaythrough",
            playVideo,
            { once: true }
          );

          /*
           * Try on next browser frame
           */
          requestAnimationFrame(() => {
            playVideo();
          });
        };

        /*
         * YouTube / Vimeo
         */
        const playExternalVideo = (
          element
        ) => {
          if (!element) return;

          if (
            element.classList.contains(
              "js-youtube"
            )
          ) {
            const symbol =
              element.src.includes("?")
                ? "&"
                : "?";

            if (
              !element.src.includes(
                "autoplay=1"
              )
            ) {
              element.src +=
                `${symbol}autoplay=1&mute=1&playsinline=1`;
            }

            return;
          }

          if (
            element.classList.contains(
              "js-vimeo"
            )
          ) {
            const symbol =
              element.src.includes("?")
                ? "&"
                : "?";

            if (
              !element.src.includes(
                "autoplay=1"
              )
            ) {
              element.src +=
                `${symbol}autoplay=1&muted=1&playsinline=1`;
            }
          }
        };

        const findAndPlayMedia = () => {
          const deferredElement =
            deferredMedia.querySelector(
              "video, model-viewer, iframe"
            );

          if (!deferredElement) {
            return false;
          }

          if (
            deferredElement.tagName ===
            "VIDEO"
          ) {
            playNativeVideo(
              deferredElement
            );
          } else if (
            deferredElement.tagName ===
            "IFRAME"
          ) {
            playExternalVideo(
              deferredElement
            );
          }

          return true;
        };

        /*
         * Load deferred content
         */
        if (
          !deferredMedia.hasAttribute(
            "loaded"
          )
        ) {
          deferredMedia.loadContent(false);
        }

        /*
         * Try immediately
         */
        if (findAndPlayMedia()) {
          return;
        }

        /*
         * Wait for Safari/deferred-media
         * to insert video element.
         */
        const observer =
          new MutationObserver(() => {
            if (
              findAndPlayMedia()
            ) {
              observer.disconnect();
            }
          });

        observer.observe(
          deferredMedia,
          {
            childList: true,
            subtree: true,
          }
        );

        /*
         * Extra Safari fallback.
         */
        let attempts = 0;

        const retryPlay = () => {
          attempts++;

          if (
            findAndPlayMedia() ||
            attempts >= 10
          ) {
            clearInterval(
              retryInterval
            );

            observer.disconnect();
          }
        };

        const retryInterval =
          setInterval(
            retryPlay,
            500
          );

        /*
         * Safety cleanup
         */
        setTimeout(() => {
          clearInterval(
            retryInterval
          );

          observer.disconnect();
        }, 5000);
      }

      handlePhotoswipe(
        customData = []
      ) {
        if (!this.enableImageZoom) return;

        const data = [];

        const medias =
          this.querySelectorAll(
            ".m-product-media--item:not(.swiper-slide-duplicate)"
          );

        if (medias) {
          medias.forEach(
            (media, index) => {
              if (
                media.dataset.mediaType ===
                "image"
              ) {
                const mediaDataItem =
                  media.querySelector(
                    ".m-product-media"
                  );

                const mediaData =
                  mediaDataItem.dataset;

                data.push({
                  src: mediaData.mediaSrc,
                  width: parseInt(
                    mediaData.mediaWidth
                  ),
                  height: parseInt(
                    mediaData.mediaHeight
                  ),
                  alt: mediaData.mediaAlt,
                  id: media.dataset.index,
                });
              } else {
                data.push({
                  html: `<div class="pswp__${media.dataset.mediaType}">${media.innerHTML}</div>`,
                  type: media.dataset.mediaType,
                  id: media.dataset.index,
                });
              }
            }
          );
        }

        this.lightbox =
          new MinimogLibs.PhotoSwipeLightbox(
            {
              dataSource:
                customData.length > 0
                  ? customData
                  : data,

              bgOpacity: 1,
              close: false,
              zoom: false,
              arrowNext: false,
              arrowPrev: false,
              counter: false,
              preloader: false,

              pswpModule:
                MinimogLibs
                  .PhotoSwipeLightbox
                  .PhotoSwipe,
            }
          );

        this.lightbox.addFilter(
          "thumbEl",
          (
            thumbEl,
            data,
            index
          ) => {
            const el =
              this.querySelector(
                '[data-index="' +
                  data.id +
                  '"]:not(.swiper-slide-duplicate) img'
              );

            if (el) {
              return el;
            }

            return thumbEl;
          }
        );

        this.lightbox.addFilter(
          "placeholderSrc",
          (
            placeholderSrc,
            slide
          ) => {
            const el =
              this.querySelector(
                '[data-index="' +
                  slide.data.id +
                  '"]:not(.swiper-slide-duplicate) img'
              );

            if (el) {
              return el.src;
            }

            return placeholderSrc;
          }
        );

        this.lightbox.on(
          "change",
          () => {
            window.pauseAllMedia(this);

            if (this.slider) {
              const currIndex =
                this.lightbox.pswp
                  .currIndex;

              if (
                this.enableVariantGroupImages
              ) {
                this.slider.slideTo(
                  currIndex,
                  100,
                  false
                );
              } else {
                this.slider.slideToLoop(
                  currIndex,
                  100,
                  false
                );
              }
            }
          }
        );

        this.lightbox.on(
          "pointerDown",
          (e) => {
            const currSlide =
              this.lightbox.pswp
                .currSlide.data;

            if (
              currSlide.type ===
              "model"
            ) {
              e.preventDefault();
            }
          }
        );

        const closeBtn = {
          name: "m-close",
          order: 11,
          isButton: true,

          html: '<svg class="m-svg-icon--large" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path></svg>',

          onClick: (
            event,
            el,
            pswp
          ) => {
            pswp.close();
          },
        };

        const arrowNext = {
          name: "m-arrowNext",
          className:
            "sf-pswp-button--arrow-next",
          order: 12,
          isButton: true,

          html: '<svg fill="currentColor" width="14px" height="14px" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path d="M218.101 38.101L198.302 57.9c-4.686 4.686-4.686-4.686-4.686-12.284 0-4.686 3.794-12.284 0-16.971l19.799-19.799c4.686-4.686 12.284-4.686 16.971 0l209.414-209.414c4.686-4.686 12.284-4.686 16.971 0l19.799 19.799c4.686 4.686 4.686 12.284 0 16.971L235.071 38.101c-4.687-4.687-12.284-4.687-16.97 0z"></path></svg>',

          onClick: (
            event,
            el,
            pswp
          ) => {
            pswp.next();
          },
        };

        const arrowPrev = {
          name: "m-arrowPrev",
          className:
            "sf-pswp-button--arrow-prev",
          order: 10,
          isButton: true,

          html: '<svg width="14px" height="14px" fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path d="M229.9 473.899l19.799-19.799c4.686-4.686 4.686-12.284 0-16.971L94.569 282H436c6.627 0 12 12-12 12H94.569l155.13-155.13c4.686-4.686 4.686-12.284 0-16.971L229.9 38.101c-4.686-4.686-12.284-4.686-16.971 0L3.515 247.515c-4.686-4.686-4.686-12.284 0-16.971L212.929 473.9c4.686 4.686 12.284 4.686 16.971-.001z"></path></svg>',

          onClick: (
            event,
            el,
            pswp
          ) => {
            pswp.prev();
          },
        };

        this.lightbox.on(
          "uiRegister",
          () => {
            this.lightbox.pswp.ui.registerElement(
              closeBtn
            );

            if (!this.onlyMedia) {
              this.lightbox.pswp.ui.registerElement(
                arrowPrev
              );

              this.lightbox.pswp.ui.registerElement(
                arrowNext
              );
            }
          }
        );
      }

      initPhotoswipe() {
        if (!this.enableImageZoom) return;

        this.lightbox.init();

        addEventDelegate({
          selector:
            this.selectors.medias[0],

          context: this,

          handler: (
            e,
            media
          ) => {
            e.preventDefault();

            const isImage =
              media.classList.contains(
                "media-type-image"
              );

            const isZoomButton =
              e.target.closest(
                this.selectors
                  .mediaZoomIns[0]
              );

            if (
              isImage ||
              isZoomButton
            ) {
              const index =
                Number(
                  media.dataset.index
                ) || 0;

              this.lightbox.loadAndOpen(
                index
              );
            }
          },
        });
      }

      setActiveMedia(variant) {
        if (!variant) return;

        if (variant.featured_media) {
          const slideIndex =
            variant.featured_media
              .position || 0;

          if (
            this.slider &&
            this.slider.wrapperEl
          ) {
            this.slider.slideToLoop(
              slideIndex - 1
            );
          }
        }
      }

      scrollIntoView(
        selectedMedia
      ) {
        selectedMedia.scrollIntoView({
          behavior: "smooth",
        });
      }

      getProductJson(productUrl) {
        return fetch(
          productUrl + ".js"
        )
          .then((response) => {
            if (!response.ok) {
              const productData =
                JSON.parse(
                  this.container.querySelector(
                    "#productData[type='application/json']"
                  ).textContent
                );

              return productData;
            } else {
              return response.json();
            }
          })
          .catch((err) =>
            console.log(err)
          );
      }
    }
  );
}